import {GET, POST} from "@/services/gateway";

const listObjects = ({pagination, objectType, backupAction, searchTerm}) => {
  return POST('entra-id/objects', {pagination, objectType, backupAction, searchTerm})
}

const listObjectEntryDetails = ({id}) => {
  return GET(`entra-id/objects/${id}`,)
}

const getStatus = () => {
  return GET('entra-id/objects/status')
}

const changeStatus = ({status, id}) => {
  return POST('entra-id/objectstatus/change', {status, id});
}

const protectAll = () => {
  return POST('entra-id/objects/protect');
}

const unprotectAll = () => {
  return POST('entra-id/objects/unprotect');
}

const exportSnapshot = (filter, objectType, backupAction, searchTerm, pagination) => {
  return POST('entra-id/entraseats/export', {filter, objectType, backupAction, searchTerm, pagination})
}

const refresh = () => {
  return GET('seat/entrausers/refresh')
}

export {
  listObjects,
  listObjectEntryDetails,
  getStatus,
  exportSnapshot,
  changeStatus,
  protectAll,
  unprotectAll,
  refresh
}
